export const RESET_USER_GUEST_STATE = 'RESET_USER_GUEST_STATE';

export const resetUserGuestStateAuthentication = () => ({
  type: RESET_USER_GUEST_STATE
});
